import * as c2pService from '@api/company-person';
import { AppBarTitle } from '@components/app-bar-title';
import { DealDetail, DealStatus } from '@lib/deals';
import { IconButton } from '@material-ui/core';
import SpellcheckRoundedIcon from '@material-ui/icons/SpellcheckRounded';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import { useRequest } from '@lib/common';
import { C2PAddForm } from '../add/form';
import { C2PReplicateForm } from './replicate-c2p-form';

export default function ReplicateC2P() {
  let deal: DealDetail = {
    id: null,
    entity1: null,
    entity1_type: null,
    entity2: null,
    entity2_type: null,
    status: DealStatus.notReviewed,
    published_date: null,
    confidence: 0,
    relation: null,
    sentences: [],
  };

  // To set duplicate deal values, get deal id from queryParam

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const originalRelationId = params.get('originalRelationId');

  const { loading: relationLoading, result: c2pdata } = useRequest(
    () => (originalRelationId ? c2pService.get(originalRelationId) : null),
    [originalRelationId],
  );
  const dealToUse: DealDetail =
    originalRelationId && c2pdata
      ? {
          ...c2pdata,
          id: null, // Important: prevent duplicating original ID
          status: DealStatus.notReviewed, // optional reset
          designation: c2pdata?.relation.designation,
          currently_working: c2pdata?.relation?.currently_working
        }
      : deal;

  // Form Actions
  const createDeal = useCallback(payload => {
    const infoNotification = enqueueSnackbar('Please wait Creating C2P relation', {
      variant: 'info',
    });
    return c2pService.post(payload).subscribe({
      next: () => {
        enqueueSnackbar('C2P Relation Created Successfully!', { variant: 'success' });
        history.push('/company-person/search');
      },
      error: err =>
        enqueueSnackbar(`Error Creating C2P relation (${err?.response?.data?.error})`, {
          variant: 'error',
        }),
      complete: () => closeSnackbar(infoNotification),
    });
  }, []);

  return (
    <div>
      <AppBarTitle>
        <IconButton onClick={null} color="inherit" edge="start">
          <SpellcheckRoundedIcon />
        </IconButton>
        Replicate relation - New C2P
      </AppBarTitle>
      <C2PReplicateForm deal={dealToUse} onSubmit={createDeal} />
    </div>
  );
}
